// extracted by mini-css-extract-plugin
export var active = "HeaderSearch-module--active--APH4R";
export var headerSearch = "HeaderSearch-module--header-search--yuSKT";
export var heading = "HeaderSearch-module--heading--mxJJ7";
export var helper = "HeaderSearch-module--helper--m91lO";
export var list = "HeaderSearch-module--list--hxPtp";
export var option = "HeaderSearch-module--option--GnV1H";
export var optionIcon = "HeaderSearch-module--option-icon--U898V";
export var panel = "HeaderSearch-module--panel--Ris3Y";